import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, Button, Typography, IconButton, TextField } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

import { oper as v_oper, basic, Values } from '../request/values';
import { COLORS } from '../shared/Theme';
import { SIcon } from '../shared/Icon';
import ToastStr from '../request/toastStr';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	paper: {
		// marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		[theme.breakpoints.up('md')]: {
			paddingTop: '0',
		},
	},
	title: {
		width: '100%',
		alignItems: 'left',
		'& img': {
			width: '45vw',
		},
		[theme.breakpoints.up('md')]: {
			width: '80%',
			'& img': {
				width: '80%',
			},
		},
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		marginTop: '5vh',
		width: '100%', // Fix IE 11 issue.
		// marginTop: theme.spacing(1),
		[theme.breakpoints.up('md')]: {
			width: '80%',
		},
	},
	submit: {
		//width: '60%',
		//height: 60,
		padding: '15px',
		marginBottom: theme.spacing(2),
		borderRadius: '12px',
		boxShadow: '6px 3px 6px 0 rgba(37, 31, 31, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		// backgroundColor: `${COLORS.WHITE}`,
		// color: `${COLORS.WATER_BLUE}`,
	},
	logoSection: {
		position: 'fixed',
		left: 0,
		right: 0,
		bottom: '5vh',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'flex-end',
	},
	header: {
		textAlign: 'center',
	},
	iconWrapper: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: theme.spacing(6), // w-16
		height: theme.spacing(6), // h-16
		backgroundColor: '#FEF3C7', // bg-amber-100
		borderRadius: '9999px', // rounded-full
		marginBottom: theme.spacing(2), // mb-4
	},
	icon: {
		color: '#D97706', // text-amber-600
		fontSize: '2rem', // size 32
	},
	titleWarning: {
		fontSize: '1rem', // text-xl
		fontWeight: 'bold',
		color: '#1F2937', // text-gray-800
	},
	container: {
		backgroundColor: '#F9FAFB', // bg-gray-50
		borderRadius: '0.75rem', // rounded-xl
		padding: theme.spacing(2), // p-4
		margin: theme.spacing(2), // mb-6
		borderWidth: '2px', // border-2
		borderStyle: 'dashed', // border-dashed
		borderColor: '#D1D5DB', // border-gray-300
		textAlign: 'center',
	},
	label: {
		fontSize: '1rem', // text-sm
		color: '#4B5563', // text-gray-600
		marginBottom: theme.spacing(0.5), // mb-2
	},
	codeText: {
		fontSize: '1.5rem', // text-2xl
		fontWeight: 'bold',
		color: '#2563EB', // text-blue-600
		marginBottom: theme.spacing(1), // mb-3
	},
	metaRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: theme.spacing(1),
		fontSize: '1rem', // text-sm
		color: '#6B7280', // text-gray-500
		marginBottom: theme.spacing(0.5),
	},
	warningRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: theme.spacing(1),
		fontSize: '1rem', // text-sm
	},
	warningText: {
		color: '#DC2626', // text-red-600
		fontWeight: 500,
	},

	input: {
		...theme.typography.subtitle1,
	},
	inputLabel: {
		...theme.typography.body1,
		color: '#000',
	},
	desc: {
		marginTop: '7vh',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: `${COLORS.WATER_BLUE}`,
		[theme.breakpoints.up('md')]: {
			fontSize: '1.75rem',
		},
	},
	code: {
		marginBottom: '2vh',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: `${COLORS.WATER_BLUE}`,
		[theme.breakpoints.up('md')]: {
			fontSize: '1.75rem',
		},
	},
	iconButtonPadding: {
		padding: '4px 8px',
		borderRadius: 8,
		marginBottom: '1.5vh',
		[theme.breakpoints.up('md')]: {
			marginLeft: '43px',
		},
	},
	selectField: {
		width: '80%',
		marginTop: theme.spacing(1),
	},
	selectRoot: {
		'& .MuiFormLabel-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiSelect-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 12,
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#cfd4d9',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
			borderWidth: 2,
		},
	},
	selectLabel: {
		backgroundColor: '#fff',
		padding: '0 4px',
	},
	menuPaper: {
		borderRadius: 12,
		boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
		marginTop: 8,
	},
	menuItem: {
		...theme.typography.body1,
		padding: theme.spacing(1.25, 1.5),
		'&:not(:last-child)': {
			borderBottom: '1px solid #f1f3f5',
		},
	},
	qrCode: {
		width: '160px',
		height: '160px',
		[theme.breakpoints.up('md')]: {
			width: '240px',
			height: '240px',
		},
	},
	logoutText: {
		margin: '0px 0px 0px 10px',
		fontSize: '14px',
		fontWeight: 'bold',
	},
	classCodeText: {
		fontSize: '18px',
		color: '#6B7280',
		marginBottom: '2vh',
	},
}));

const OperCreateClass: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('oper');

	const [classCode, setClassCode] = useState<string>('');
	const [checkNew, setCheckNew] = useState<boolean>(false);
	const [label, setLabel] = useState(t('OperOpenClass.labelDefault'));
	const [input, setInput] = useState<string>('');
	let history = useHistory();
	const { enqueueSnackbar } = useSnackbar();
	const { member, setMember, deleteMember } = props;

	const logout = () => {
		deleteMember();
		history.push('/');
	};

	const handleBack = () => {
		setCheckNew(false);
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setInput(value);
	};

	const handleFocus = () => {
		setLabel(t('OperOpenClass.labelClassCode'));
	};

	const handleBlur = () => {
		if (classCode === '') {
			setLabel(t('OperOpenClass.labelDefault'));
		}
	};

	const getClassCodeInfo = async (classCode: string) => {
		const response = await axios.get(SERVER + v_oper.oper + v_oper.class_info, { params: { classCode: classCode } });
		if (response.data.code == Values.SUCCESS_CODE) {
			setClassCode(response.data.classInfo[0].class_code);
		} else {
			setClassCode('');
		}
	};

	const handleClassEnter = () => {
		history.push({
			pathname: '/operation/company/list',
		});
	};

	const handleClassEnterNew = () => {
		if (input === '') {
			enqueueSnackbar(ToastStr.CLASS_CODE_CHECK_STR, { variant: 'warning' });
			return;
		}
		try {
			axios({
				method: 'POST',
				data: {
					email: member.id,
					classCode: input,
				},
				withCredentials: true,
				url: SERVER + v_oper.oper + v_oper.class_enter,
			})
				.then((res) => res.data)
				.then(async (data: any) => {
					if (data.code === Values.SUCCESS_CODE) {
						await setMember(Object.assign({}, member, { classCode: input, classVersion: data.class_version }));
						history.push({
							pathname: '/operation/company/list',
						});
						enqueueSnackbar(ToastStr.CLASS_ENTER_SUCCESS, {
							variant: 'success',
						});
					} else if (data.code === Values.CLASS_CODE_NOT_FOUND_CODE) {
						enqueueSnackbar(ToastStr.CLASS_CODE_NOT_FOUND_STR, { variant: 'warning' });
					} else if (data.code === Values.CLASS_NO_START_CODE) {
						enqueueSnackbar(ToastStr.CLASS_NO_START_STR, { variant: 'warning' });
					} else if (data.code === Values.CLASS_FINISH_CODE) {
						enqueueSnackbar(ToastStr.CLASS_ALREADY_END_STR, { variant: 'warning' });
					} else {
						enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, { variant: 'error' });
					}
				});
		} catch (e: any) {
			enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error' });
		}
	};

	useEffect(() => {
		const member = localStorage.getItem('member');
		if (member) {
			const memberData = JSON.parse(member);
			if (memberData.classCode && memberData.classCode !== '') {
				getClassCodeInfo(memberData.classCode);
				return;
			}
		}
	}, []);

	return (
		<>
			<div className={classes.paper}>
				<div style={{ width: '100%' }}>
					{!checkNew ? (
						<IconButton className={classes.iconButtonPadding} onClick={() => logout()}>
							<img src="/images/logout.webp" style={{ width: '6vw', maxWidth: '24px' }} />
							<p className={classes.logoutText}>{t('OperCreateClass.logout')}</p>
						</IconButton>
					) : (
						<IconButton className={classes.iconButtonPadding} onClick={() => handleBack()}>
							<img src="/images/back.png" style={{ width: '6vw', maxWidth: '24px' }} />
							<p className={classes.logoutText}>{t('OperCreateClass.back')}</p>
						</IconButton>
					)}
				</div>
				<div className={classes.title}>
					<img src="/images/logo.webp" />
				</div>

				<>
					{!checkNew && classCode !== '' ? (
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginTop: '5vh' }}>
							{classCode && classCode !== '' && (
								<div className={classes.classCodeText}>
									{t('OperOpenClass.classCodeNow')}
									{classCode}
								</div>
							)}
							<Button className={classes.submit} onClick={() => handleClassEnter()} style={{ background: `${COLORS.PUMPKIN}` }}>
								<Typography variant="h3" style={{ color: 'white', fontFamily: 'NanumR', fontWeight: 'bold' }}>
									{t('OperOpenClass.keepUsing')}
								</Typography>
							</Button>
							<Button className={classes.submit} onClick={() => setCheckNew(true)} style={{ background: `${COLORS.WATER_BLUE}` }}>
								<Typography variant="h3" style={{ color: 'white', fontFamily: 'NanumR', fontWeight: 'bold' }}>
									{t('OperOpenClass.enterNew')}
								</Typography>
							</Button>
						</div>
					) : (
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginTop: '5vh' }}>
							{classCode && classCode !== '' && (
								<div className={classes.classCodeText}>
									{t('OperOpenClass.classCodeNow')}
									{classCode}
								</div>
							)}
							<div className={classes.form}>
								<TextField
									variant="standard"
									margin="normal"
									required
									fullWidth
									id="classCode"
									label={label}
									name="classCode"
									autoComplete="off"
									autoFocus
									onFocus={handleFocus}
									onBlur={handleBlur}
									inputProps={{ maxLength: 12 }}
									InputProps={{ classes: { input: classes.input } }}
									InputLabelProps={{
										classes: { root: classes.inputLabel },
									}}
									value={input}
									onChange={valueChangeHandler}
									style={{ color: `${COLORS.CHARCOAL_GREY}` }}
								/>
								<Button fullWidth className={classes.submit} onClick={() => handleClassEnterNew()}>
									<Typography
										variant="h3"
										style={{
											color: `${COLORS.WATER_BLUE}`,
											fontFamily: 'NanumR',
											fontWeight: 'bold',
										}}
									>
										{t('OperOpenClass.enter')}
									</Typography>
								</Button>
							</div>
						</div>
					)}
				</>
			</div>
			<div className={classes.logoSection}>
				<SIcon type="P" />
			</div>
		</>
	);
};

export default OperCreateClass;
